import { useCallback } from "react";
import { useRecoilValue } from "recoil";

import { isSubset } from "../helpers";
import { profileScopeAtom } from "../recoil";

interface IProfileAuthorizationPayload {
  siteIds?: number[];
  unitIds?: number[];
  supplierIds?: number[];
  rideTypeIds?: number[];
}

interface IUseProfileAuthorizationCheckResponse {
  profileAuthorizationInCheck: (
    propsCheck: IProfileAuthorizationPayload,
  ) => boolean;
}

export const useProfileAuthorizationCheck =
  (): IUseProfileAuthorizationCheckResponse => {
    const profileScope = useRecoilValue(profileScopeAtom);

    const profileAuthorizationInCheck = useCallback(
      ({
        unitIds,
        siteIds,
        supplierIds,
        rideTypeIds,
      }: IProfileAuthorizationPayload) => {
        // Empty required or empty allowed ⇒ unrestricted for that dimension (isSubset).
        return (
          isSubset(unitIds, profileScope?.unitIds) &&
          isSubset(siteIds, profileScope?.siteIds) &&
          isSubset(supplierIds, profileScope?.supplierIds) &&
          isSubset(rideTypeIds, profileScope?.rideTypeIds)
        );
      },
      [profileScope],
    );

    return { profileAuthorizationInCheck };
  };
